import React from 'react'
import { COLORS } from '@helpers/constants'
import Icon from '@components/Icon'

const RightNav = React.memo(({onClick, disabled}) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="mr-4 rounded-full transition-all cursor-pointer absolute z-[4] outline-none bg-black right-0 top-1/2 transform translate-y-[-50%] w-[40px] h-[40px]"
        disabled={disabled}
        onClick={onClick}
        aria-label="Previous Slide"
      >
        <div className="flex justify-center w-full">
          <Icon icon={'ChevronRight'} color={disabled ? COLORS.LIGHT_DARK_GREY.TEXT : COLORS.WHITE.TEXT} />
        </div>
      </button>
    </div>
  )
})

export default RightNav
